module.exports = __webpack_public_path__ + "img/9.3b2ddd6c.jpg";